"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ClubTreasurerDetails;
var _react = _interopRequireDefault(require("react"));
var _formGroup = _interopRequireDefault(require("../core/form-group"));
var _label = _interopRequireDefault(require("../core/label"));
var _col = _interopRequireDefault(require("../core/col"));
var _AddressEditor = _interopRequireDefault(require("./AddressEditor"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Input = require("../core/input").default;
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "First Name");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Last Name");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Date of Birth");
var _ref4 = /*#__PURE__*/_react.default.createElement("strong", null, "Personal Address");
function ClubTreasurerDetails({
  club,
  onChangeValue
}) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(Input, {
    type: "text",
    name: "firstName",
    value: club.firstName,
    onChange: onChangeValue,
    required: true
  }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(Input, {
    type: "text",
    name: "lastName",
    value: club.lastName,
    onChange: onChangeValue,
    required: true
  }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(Input, {
    type: "Date",
    name: "dob",
    value: club.dob,
    onChange: onChangeValue,
    required: true
  }))), _ref4, /*#__PURE__*/_react.default.createElement(_AddressEditor.default, {
    name: "address",
    value: club.address,
    onChange: onChangeValue
  }));
}